import { v4 as uuidv4 } from 'uuid';
import { api } from '../../singletons';
import { AD_MEDIUM_TYPES, AD_SLOTS } from '../constants';
const BASE_DEFAULT_FIELDS = {
    adType: AD_MEDIUM_TYPES.AUDIO,
    adSlot: AD_SLOTS.PREROLL,
};
const DEFAULT_FIELDS = {
    ...BASE_DEFAULT_FIELDS,
    adNetworkName: '',
    adUnitId: '',
};
const PLAYBACK_DEFAULT_FIELDS = {
    ...DEFAULT_FIELDS,
    adCreativeId: '',
    currentVideoaudiorollIdx: 1,
    noOfVideoaudiorollsReceived: 1,
    isStreamPrebuffered: false,
    prebufferTimeMs: 0,
    props: {},
};
const TIMER_DEFAULT_FIELDS = {
    adRequestDefaultTimer: true,
    midrollTimerInSeconds: 0,
};
export class ServerSidePrerollReporter {
    #requestId;
    #didPlay = false;
    #wasPaused = false;
    #bitrate = 0;
    reportEligibility(isEligible = false, bitrate = 0) {
        this.#requestId = uuidv4();
        this.#didPlay = false;
        this.#wasPaused = false;
        this.#bitrate = bitrate;
        api.telemetry.reportAdsVideoAudioRollEligibilityDecided({
            ...BASE_DEFAULT_FIELDS,
            isPlatformEligible: isEligible,
            isEligible,
            maxRolls: 0,
            maxTotalRolls: 0,
        });
    }
    reportRequested() {
        api.telemetry.reportAdsVideoAudioRollRequested({
            ...DEFAULT_FIELDS,
            ...TIMER_DEFAULT_FIELDS,
            adRequestId: this.#requestId,
            adRequestHasAmazonKeywords: false,
            biddingNetworks: [{ requestId: '', networkName: '', isIncluded: false }],
            maxRolls: 0,
            maxTotalRolls: 0,
        });
    }
    reportResponseReceived({ adUnitId } = {}) {
        api.telemetry.reportAdsVideoAudioRollResponseReceived({
            ...BASE_DEFAULT_FIELDS,
            ...TIMER_DEFAULT_FIELDS,
            adRequestId: this.#requestId,
            adNetworkName: '',
            noOfVideoaudiorollsReceived: 1,
            bitrate: this.#bitrate,
            adUnitId: adUnitId || '',
        });
    }
    reportPlaying() {
        if (this.#wasPaused) {
            this.#wasPaused = false;
            api.telemetry.reportAdsPlaybackResumed({
                ...PLAYBACK_DEFAULT_FIELDS,
                adRequestId: this.#requestId,
            });
            return;
        }
        if (this.#didPlay) {
            return;
        }
        this.#didPlay = true;
        api.telemetry.reportAdsPlaybackStarted({
            ...PLAYBACK_DEFAULT_FIELDS,
            ...TIMER_DEFAULT_FIELDS,
            adRequestId: this.#requestId,
            bitrate: this.#bitrate,
        });
    }
    reportFailed({ error, adUnitId, adNetworkName, }) {
        if (this.#didPlay) {
            api.telemetry.reportAdsPlaybackFailed({
                ...PLAYBACK_DEFAULT_FIELDS,
                ...TIMER_DEFAULT_FIELDS,
                adRequestId: this.#requestId,
                errorCode: error?.message || '',
                errorMessage: error?.message || '',
                bitrate: this.#bitrate,
                debugDescription: '',
            });
            return;
        }
        api.telemetry.reportAdsVideoAudioRollRequestFailed({
            ...BASE_DEFAULT_FIELDS,
            ...TIMER_DEFAULT_FIELDS,
            adRequestId: this.#requestId,
            errorCode: error?.message || '',
            errorMessage: error?.message || '',
            debugDescription: '',
            adUnitId: adUnitId || '',
            adNetworkName: adNetworkName || '',
        });
    }
    reportFinished() {
        api.telemetry.reportAdsPlaybackFinished({
            ...PLAYBACK_DEFAULT_FIELDS,
            ...TIMER_DEFAULT_FIELDS,
            adRequestId: this.#requestId,
            wasAdSkipped: false,
            wasAdCancelled: false,
        });
    }
    reportPaused() {
        this.#wasPaused = true;
        api.telemetry.reportAdsPlaybackPaused({
            ...PLAYBACK_DEFAULT_FIELDS,
            adRequestId: this.#requestId,
            debugDescription: '',
        });
    }
}
